import React from 'react'

export const ChevronRight = (props) => {
    const { width, height } = props
    return <svg width={width} height={height} version="1.1" viewBox="0 0 21.167 44.979" xmlns="http://www.w3.org/2000/svg">
    <path d="m0.35127 0.36847 20.079 22.13-20.07 22.097" fill="none" stroke="#000" strokeWidth="3.0926"/>
   </svg>

}